import React, { useEffect } from 'react'
import injectSheet from 'react-jss/lib/injectSheet'
import { accessibilityColors } from '../../colors'
import THEME from 'pobble-components/dist/theme'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck'

const { COLORS } = THEME

const successCriteriaThumbnailStyles = {
  container: {
    width: '100%',
    height: '100%',
    padding: '1em',
    overflow: 'hidden'
  },
  table: {
    fontSize: '.4em',
    fontWeight: 'bold',
    color: COLORS.TEXT.MID_GREY.NORMAL,
    boxShadow: '0 0 1em rgba(0, 0, 0, .05)',
    borderStyle: '.5em',
    width: '100%',
    borderCollapse: 'collapse',
    lineHeight: '1.2',
    '& td': {
      border: '1px solid #ccc',
      padding: '1em'
    },
    '& th': {
      color: '#fff',
      padding: '.5em .6em',
      background: '#4A4A4A',
      border: '1px solid #4A4A4A',
      '&:first-child': {
        borderRightColor: '#fff'
      }
    }
  },
  markCell: {
    width: '1em'
  }
}

const SuccessCriteriaThumbnail = injectSheet(successCriteriaThumbnailStyles)(
  ({ classes, presentation, slide, onLoad }) => {
    useEffect(() => {
      onLoad()
    }, [])

    return (
      <div
        className={classes.container}
        style={{
          backgroundColor: accessibilityColors[presentation.accessibility_color]
        }}>
        <table className={classes.table}>
          <thead>
            <tr>
              <th></th>
              <th>
                <FontAwesomeIcon icon={faCheck} />
              </th>
            </tr>
          </thead>
          <tbody>
            {slide.criteria &&
              slide.criteria.map((criteria, index) => {
                return (
                  <tr key={index}>
                    <td>{criteria.criterion}</td>
                    <td className={classes.markCell} />
                  </tr>
                )
              })}
          </tbody>
        </table>
      </div>
    )
  }
)

export default SuccessCriteriaThumbnail
